require('../../modules/es6.number.max-safe-integer');
module.exports = 0x1fffffffffffff;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/number/max-safe-integer.js
// module id = 344
// module chunks = 0